const sortPlansByOrder = ({ offersRef }) => {
  if (Array.isArray(offersRef?.[0]?.plans)) {
    offersRef?.[0]?.plans.sort((a, b) => a.order - b.order);
  }

  return offersRef;
};

export default sortPlansByOrder;
